import React from "react";
import { patientLabel, saveBadgeLabel, saveKeyForPatient } from "../model/cnoRules";
import CnoLinesSection from "./CnoLinesSection";
import {
    actionsStyle,
    detailHeaderStyle,
    detailStyle,
    eyebrowStyle,
    identityGridStyle,
    inputStyle,
    labelStyle,
    noSelectionStyle,
    saveBadgeStyle,
    secondaryButtonStyle,
} from "./cnoStyles";

const IDENTITY_FIELDS = [
    ["nom", "Nom"],
    ["prenom", "Prénom"],
    ["adresse", "Adresse"],
    ["telephone", "Numéro de téléphone"],
];

function SaveBadge({ status }) {
    const label = saveBadgeLabel(status);
    if (!label) return null;
    return <span className="cno-save-badge" style={saveBadgeStyle(status)}>{label}</span>;
}

function NoSelection() {
    return (
        <div style={noSelectionStyle}>
            <h2 style={{ marginBottom: "6px" }}>Aucune fiche sélectionnée</h2>
            <p style={{ margin: 0, color: "#7b8494" }}>Ajoutez un patient pour saisir ses CNO.</p>
        </div>
    );
}

// Fiche du patient sélectionné : identité éditable et lignes CNO.
export default function CnoPatientSheet({ patient, saveStatuses, onContextMenu, onUpdatePatient, onSavePatient, lineActions }) {
    if (!patient) return <NoSelection />;
    return (
        <section style={detailStyle}>
            <div style={detailHeaderStyle} onContextMenu={event => onContextMenu(event, patient)}>
                <div>
                    <span style={eyebrowStyle}>Fiche patient</span>
                    <h2 style={{ margin: "5px 0 0", color: "#111827" }}>{patientLabel(patient)}</h2>
                </div>
                <div style={actionsStyle}>
                    <SaveBadge status={saveStatuses[saveKeyForPatient(patient.id)]} />
                    <button type="button" style={secondaryButtonStyle}>
                        Voir les livraisons
                    </button>
                </div>
            </div>

            <div style={identityGridStyle}>
                {IDENTITY_FIELDS.map(([field, label]) => (
                    <label key={field} style={labelStyle}>
                        {label}
                        <input
                            style={inputStyle}
                            value={patient[field]}
                            onChange={event => onUpdatePatient({ [field]: event.target.value })}
                            onBlur={event => onSavePatient(patient, { [field]: event.target.value })}
                        />
                    </label>
                ))}
            </div>

            <CnoLinesSection {...lineActions} lines={patient.cnos || []} />
        </section>
    );
}
